var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"calendar"}},[_c('FullCalendar',{staticClass:"mt-3",attrs:{"defaultView":"resourceTimeline","plugins":_vm.calendarPlugins,"events":_vm.events,"resources":_vm.resources,"height":_vm.height}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }